module.exports = __webpack_public_path__ + "img/DE05735.982586d1.png";